/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { useRef, useEffect } from "react";

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { IObrienFfViewProps } from './obrien-ff';

export default (props: IObrienFfViewProps) => {

    let animateThis1 = useRef(null);
    let animateThat1 = useRef(null);
    let animateThis2 = useRef(null);
    let animateThat2 = useRef(null);
    let animateThis3 = useRef(null);
    let animateThat3 = useRef(null);
    let animateThis4 = useRef(null);
    let animateThat4 = useRef(null);
    let animateThis5 = useRef(null);
    let animateThat5 = useRef(null);
    let animateThis6 = useRef(null);
    let animateThat6 = useRef(null);
    let animateThis7 = useRef(null);
    let animateThat7 = useRef(null);
    let animateThis8 = useRef(null);
    let animateThat8 = useRef(null);

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
    
        gsap.to( animateThis1, {
            scrollTrigger: {
                trigger: '.feature1', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat1, {
            scrollTrigger: {
                trigger: '.feature1',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis2, {
            scrollTrigger: {
                trigger: '.feature2', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat2, {
            scrollTrigger: {
                trigger: '.feature2',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis3, {
            scrollTrigger: {
                trigger: '.feature3', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat3, {
            scrollTrigger: {
                trigger: '.feature3',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis4, {
            scrollTrigger: {
                trigger: '.feature4', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat4, {
            scrollTrigger: {
                trigger: '.feature4',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis5, {
            scrollTrigger: {
                trigger: '.feature5', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat5, {
            scrollTrigger: {
                trigger: '.feature5',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis6, {
            scrollTrigger: {
                trigger: '.feature6', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat6, {
            scrollTrigger: {
                trigger: '.feature6',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })

        gsap.to( animateThis7, {
            scrollTrigger: {
                trigger: '.feature7', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat7, {
            scrollTrigger: {
                trigger: '.feature7',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })

        gsap.to( animateThis8, {
            scrollTrigger: {
                trigger: '.feature8', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat8, {
            scrollTrigger: {
                trigger: '.feature8',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })

    
    
    }, [])

    const { 
        obFFTitle1, 
        obFFTitle2, 
        obFFTitle3,
        obFFTitle4,
        obFFTitle5,
        obFFTitle6,
        obFFTitle7,
        obFFTitle8, 
        obFFContent1, 
        obFFContent2,
        obFFContent3,
        obFFContent4, 
        obFFContent5,
        obFFContent6,
        obFFContent7,
        obFFContent8, 
        obFFImage1,
        obFFImage2,
        obFFImage3,
        obFFImage4,
        obFFImage5,
        obFFImage6,
        obFFImage7,
        obFFImage8,
        links1,
        links2,
        links3,
        links4,
        links5,
        links6,
        links7,
        links8
    } = props;

    return (
        <div className="feature-focus">
            <div className="white-background">
                <div className="inside-xxl">
                
           
                {obFFImage1 ? (
                    <div className="flex-md feature1">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis1 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat1 = el}}
                                >
                                    {obFFImage1}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle1}</div>
                                <div className="feature-content">{obFFContent1}</div>
                                {links1}
                            </div>
                        </div>
                    </div>
                ) : null}

                {obFFImage2 ? (
                    <div className="flex-md feature2">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis2 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat2 = el}}
                                >
                                    {obFFImage2}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle2}</div>
                                <div className="feature-content">{obFFContent2}</div>
                                {links2}
                            </div>
                        </div>
                    </div>
                ) : null}

                {obFFImage3 ? (
                    <div className="flex-md feature3">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis3 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat3 = el}}
                                >
                                    {obFFImage3}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle3}</div>
                                <div className="feature-content">{obFFContent3}</div>
                                {links3}
                            </div>
                        </div>
                    </div>
                ) : null}

                {obFFImage4 ? (
                    <div className="flex-md feature4">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis4 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat4 = el}}
                                >
                                    {obFFImage4}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle4}</div>
                                <div className="feature-content">{obFFContent4}</div>
                                {links4}
                            </div>
                        </div>
                    </div>
                ) : null}

                {obFFImage5 ? (
                    <div className="flex-md feature5">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis5 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat5 = el}}
                                >
                                    {obFFImage5}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle5}</div>
                                <div className="feature-content">{obFFContent5}</div>
                                {links5}
                            </div>
                        </div>
                    </div>
                ) : null}

                {obFFImage6 ? (
                    <div className="flex-md feature6">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis6 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat6 = el}}
                                >
                                    {obFFImage6}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle6}</div>
                                <div className="feature-content">{obFFContent6}</div>
                                {links6}
                            </div>
                        </div>
                    </div>
                ) : null}

                {obFFImage7 ? (
                    <div className="flex-md feature7">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis7 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat7 = el}}
                                >
                                    {obFFImage7}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle7}</div>
                                <div className="feature-content">{obFFContent7}</div>
                                {links7}
                            </div>
                        </div>
                    </div>
                ) : null}

                {obFFImage8 ? (
                    <div className="flex-md feature8">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis8 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat8 = el}}
                                >
                                    {obFFImage8}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                            <div>
                                <div className='title-container'>{obFFTitle8}</div>
                                <div className="feature-content">{obFFContent8}</div>
                                {links8}
                            </div>
                        </div>
                    </div>
                ) : null}
                
                </div>
       
            </div>
        </div>
        
    );
};
